var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockerTransperent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6V8H7V6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6ZM6 8V6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6V8C15.1046 8 16 8.89543 16 10V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V10C4 8.89543 4.89543 8 6 8ZM14 9H13H7H6C5.44772 9 5 9.44772 5 10V16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16V10C15 9.44772 14.5523 9 14 9Z",
    fill: "#DADAEA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerTransperent);
export default __webpack_public_path__ + "static/media/locker-transperent.77d577664da75780f7a61e82b961ff52.svg";
export { ForwardRef as ReactComponent };